import List from "@/components/list";
import Bus from "./Bus.js";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  function downloadFile(data) {
    Bus.$emit("downloadFile", data);
  }
  function removeFile(data) {
    Bus.$emit("removeFile", data);
  }

  const Deal = ({ props: { vo } }) => {
    const data = vo.row.uuid;
    let dealConf = [
      ["iconfont ic_download iconfont-adapt", "下载", () => downloadFile(data), "fileLibrary:download"],
      ["icon-delete", "删除", () => removeFile(data), "fileLibrary:delete"]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "文件名称",
      prop: "fileName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "上传者",
      prop: "createUserName",
      minWidth: "120"
    },
    {
      label: "上传时间",
      prop: "createDate",
      minWidth: "120"
    },
    {
      label: "下载次数",
      prop: "downloadNum",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "120",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
